import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { EditIconButton, DeleteIconButton } from "../../../../assets/common-svg/CommonSvg";
import Datatable from "../../../components/features/Datatable";
import { fetchAllEmailsTemplates, deleteEmailTemplate } from "../../../slices/emailTemplates";
import { combinedRoles } from "../../../slices/roles";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";

const EmailTemplateToggle = ({ value, onChange }) => {
    return (
        <ToggleButtonGroup
            exclusive
            value={value}
            onChange={(e, newValue) => {
                if (newValue !== null) onChange(newValue);
            }}
            className="bg-gray-100 rounded-xl"
            sx={{
                "& .MuiToggleButtonGroup-grouped": {
                    margin: 0,
                    border: "none",
                    borderRadius: "10px !important",
                    textTransform: "none",
                    fontSize: "14px",
                    fontWeight: 500,
                    padding: "8px 20px",
                    color: "#6B7280",
                },
                "& .Mui-selected": {
                    backgroundColor: "#3B82F6 !important",
                    color: "#ffffff !important",
                },
            }}
        >
            <ToggleButton value="create_email_template">
                Create Email Template
            </ToggleButton>

            <ToggleButton value="assign_email_template">
                Assign Email Template
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

EmailTemplateToggle.propTypes = {
    value: PropTypes.oneOf(["create_email_template", "assign_email_template"]).isRequired,
    onChange: PropTypes.func.isRequired,
};

const EmailTemplate = () => {
    const dispatch = useDispatch()
    // const [data, setData] = useState([])
    const [open, setOpen] = useState(false);
    const [rowData, setRowData] = useState(null)
    const [isLoading, setIsLoading] = useState()
    const { allEmailsTemplates } = useSelector(state => state.emailTemplates);
    const [portalSelected, setPortalSelected] = useState('create_email_template');
    const navigate = useNavigate()
    const columns = [
        {
            id: 'name',
            name: 'Name',
            align: "left",
            selector: row =>row?.name,

            sortable: true
        },
        {
            id: 'subject',
            align: "left",
            name: 'Subject',
            selector: row => row?.subject,
            sortable: true
        },
        {
            id: 'type',
            align: "left",
            name: 'Type',
            selector: row => row?.communication_type?.name,
            sortable: true
        },
        {
            id: 'status',
            name: 'Status',
            align: "left",
            selector: row => row?.status == "Active"? <Typography className="text-[#369c50]">Active</Typography> : <Typography className="text-[#FF2023]">In-Active</Typography>,
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row?.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => {navigate(`create-notification-center/${row?.id}`) }}
                        >
                            <EditIconButton
                                bgColor={"#3571FF"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete" >
                    <span>
                     <IconButton
                        onClick={() => { setRowData(row), setOpen(true) }}
                     >
                     <DeleteIconButton
                        bgColor={"#FA5151"}
                     />
                    </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];
     const removeTemplate = async () => {
            if (!rowData?.id) return;

            try {  await dispatch(deleteEmailTemplate({ id: rowData.id })).unwrap();
                setOpen(false);
                await dispatch(fetchAllEmailsTemplates());
            } catch (error) {
                console.error("Delete failed:", error);
            }
        }


    // const fetchData = async () => {
    //     await dispatch(fetchAllEmailsTemplates())

    // }
    const handleServerSideChange = async (params) => {
        let payload = {
            page: params.page,
            limit: params.per_page,
            search: params.search,
            sort_by: params.sort_by,
            order_by: params.sort_order
        }
        try {
            setIsLoading(true)

            await dispatch(
                fetchAllEmailsTemplates(payload)
            )
        } catch (error) {
            console.error("Error fetching template list:", error)
        } finally {
            setIsLoading(false)
        }
    }

    const updateFilter = (params) => {
        handleServerSideChange(params)
    }
    const handleToggleChange = (value) => {
        if (value) {
            setPortalSelected(value)
        }
    }
 
    useEffect(() => {
        dispatch(combinedRoles());
    }, []);

    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            {/* <BsModal open={addModal} onClose={handleCloseModal} title={rowData ? "Edit Location" : "Add New Location"}>
                <CETModal editData={rowData} />
            </BsModal> */}
            {portalSelected === 'create_email_template' ?
                <Datatable
                    columns={columns}
                    data={{ items: allEmailsTemplates?.data, total_count: allEmailsTemplates?.page_details?.total_records }}
                    title="Notification Center"
                    loading={isLoading}
                    remote={true}
                    onServerSideChange={updateFilter}
                    searchPlaceholder="Search by Name"
                    BtnComponent={<Button className="ml-2 w-auto" onClick={() => (navigate('create-notification-center'))}>Create Notification Center</Button>}
                />
                :
                    <Datatable
                        columns={columns}
                        data={allEmailsTemplates}
                        title={
                            <EmailTemplateToggle
                                value={portalSelected}
                                onChange={handleToggleChange}
                            />
                        }
                        searchPlaceholder="Search by Name"
                        BtnComponent={<Button className="ml-2 w-auto" onClick={() => { }}>Assign Notification</Button>}
                    />
            }
             <DeleteModal
                        open={open}
                        setClose={setOpen}
                        title={"Are you sure you want to Delete ?"}
                        buttonText={"Delete"}
                        handleSuccess={removeTemplate}
                    />
        </div>
    </div>
}
export default EmailTemplate